import { FormlyFieldConfig } from '@ngx-formly/core';
import { TranslateService } from '@ngx-translate/core';

export class TranslateLabelExtension {
    constructor(private translate: TranslateService) {}
    prePopulate(field: FormlyFieldConfig) {
        const props = field.props || {};
        if (!props.label) {
            return;
        }
        field.expressions = {
            ...(field.expressions || {}),
            'props.label': this.translate.stream(field.props?.label!),
        };
    }
}

export class TranslatePlaceholderExtension {
    constructor(private translate: TranslateService) {}
    prePopulate(field: FormlyFieldConfig) {
        const props = field.props || {};
        if (!props.placeholder) {
            return;
        }
        field.expressions = {
            ...(field.expressions || {}),
            'props.placeholder': this.translate.stream(
                field.props?.placeholder!
            ),
        };
    }
}

export function registerTranslateExtension(translate: TranslateService) {
    return {
        extensions: [
            {
                name: 'translate-label-extension',
                extension: new TranslateLabelExtension(translate),
            },
            {
                name: 'translate-placeholder-extension',
                extension: new TranslatePlaceholderExtension(translate),
            },
        ],
    };
}
